import { memo } from "react"

import {
  GlobalSearchOption,
  GlobalSearchOptionsMap
} from "features/global-search/types/GlobalSearch"

import { GlobalSearchContext } from "./GlobalSearchContext"
import { GlobalSearchInputContext } from "./GlobalSearchInputContext"
import { GlobalSearchNavigationContext } from "./GlobalSearchNavigationContext"
import { useGlobalSearchViewModel } from "./model/useGlobalSearchViewModel"
import "./styles/_global-search.scss"
import { GlobalSearchButton } from "./ui/GlobalSearchButton"
import { GlobalSearchInput } from "./ui/GlobalSearchInput"
import { GlobalSearchSearchHistory } from "./ui/GlobalSearchSearchHistory"
import { GlobalSearchStatus } from "./ui/GlobalSearchStatus"
import { GlobalSearchTabs } from "./ui/tabs/GlobalSearchTabs"

export interface GlobalSearchRootProps {
  children: React.ReactNode
  searchTerm: string | null
  onSearchTermChange: (value: string | null) => void
  options: GlobalSearchOptionsMap
  isLoading: boolean
  onChange: (option: GlobalSearchOption | null) => void
  history: string[]
}

const GlobalSearchRoot = memo(
  ({ children, ...props }: GlobalSearchRootProps) => {
    const { searchContextValue, inputContextValue, navigationContextValue } =
      useGlobalSearchViewModel(props)

    return (
      <GlobalSearchContext.Provider value={searchContextValue}>
        <GlobalSearchInputContext.Provider value={inputContextValue}>
          <GlobalSearchNavigationContext.Provider
            value={navigationContextValue}
          >
            {children}
          </GlobalSearchNavigationContext.Provider>
        </GlobalSearchInputContext.Provider>
      </GlobalSearchContext.Provider>
    )
  }
)

export const GlobalSearch = Object.assign(GlobalSearchRoot, {
  Input: GlobalSearchInput,
  Button: GlobalSearchButton,
  Tabs: GlobalSearchTabs,
  Status: GlobalSearchStatus,
  SearchHistory: GlobalSearchSearchHistory
})
